import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { ISystemControlPromiseLookupService } from "../ISystemControlPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Subject } from "rxjs";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class SystemControlPromiseLookupService
  extends PromiseLookupService<string, CubiqTS.SystemControlImpl>
  implements ISystemControlPromiseLookupService
{
  constructor() {
    super();
    // debugger;
  }
  abstract setSystemStatus(systemControl: CubiqTS.SystemControlImpl): Promise<void>;
  abstract getPanicSubject(): Subject<CubiqTS.SystemControlImpl>;
}
